import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ClaimDto} from "../../auto-generated-server-dtos/list-claims/claim-dto";
import {DeleteClaimServiceService} from "./services/delete-claim-service.service";

@Component({
  selector: 'app-delete-claim',
  templateUrl: './delete-claim.component.html',
  styleUrl: './delete-claim.component.scss'
})
export class DeleteClaimComponent {
  @Input() claim!: ClaimDto;
  @Output() deletedClaim = new EventEmitter<ClaimDto>();
  isDeleting = false;

  constructor(public activeModal: NgbActiveModal, private deleteClaimService: DeleteClaimServiceService) {
  }

  deleteClaim() {
    this.isDeleting = true;
    this.deleteClaimService.DeleteClaim(this.claim.claimId).subscribe(() => {
      this.activeModal.close(this.claim.claimId);
      this.deletedClaim.emit(this.claim);
    });
  }
}
